<script>
    import moment from 'moment';
    var swal = require('sweetalert');
    import { http } from '@/system/http';
    import { getQueryParam } from '@/system/helpers';
    import { isValidZipCode } from '@/system/helpers/zipCodeValidation';

    export default {
        data() {
            return {
                action: 'subscribe',
                loading: true,
                monthly: true,
                orderlines : [],
                paymentParams: {},
                has_valid_payment_card: false,
                step: 'subscription_select',
                card_order: null,
                card_action: null,
                discount_code: '',
                has_discounts: false,
                params: null,

                // User info data
                name: '',
                email: '',
                phone: '',
                address: '',
                zip: '',
                city: '',
                cvr: '',
                is_vat_registered: false,
                paymentWindow: null,
                paymentFailureCount: 0,
            }
        },

        props : {
            user: {
                required: true,
            },
            has_invoice_info : {
                default : 0
            },
            is_onboarding: {
                required: false,
                default: false
            },
            errorMessage: {
                required: false,
                default: '',
            },
            paymentProvider: {
                required: true,
                validator: val => ['epay', 'onpay'].includes(val),
            },
            wantsToSubscribe: {
                required: false,
                default: false
            },
            on_tour: {
                type: Boolean,
                required: false,
                default: false,
            },
            from_tour: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
        mounted() {
            if (this.is_onboarding) {
                this.loadOrderlines();
            }

            this.name = this.user.invoiceinfo ? this.user.invoiceinfo.name : this.user.realname;
            this.email = this.user.invoiceinfo ? this.user.invoiceinfo.email : this.user.email;
            this.cvr = this.user.invoiceinfo ? this.user.invoiceinfo.cvr : this.user.cvr;
            this.address = this.user.invoiceinfo ? this.user.invoiceinfo.address : this.user.address;
            this.zip = this.user.invoiceinfo ? this.user.invoiceinfo.zip : this.user.zip;
            this.city = this.user.invoiceinfo ? this.user.invoiceinfo.city : this.user.city;
            this.phone = this.user.invoiceinfo ? this.user.invoiceinfo.phone : this.user.phone;

            if (this.paymentProvider === 'epay') {
                // Insert external payment provider javacsript.
                var el = document.createElement('script');
                el.setAttribute('type', 'text/javascript');
                el.setAttribute('charset', 'UTF-8');
                el.setAttribute('src', 'https://ssl.ditonlinebetalingssystem.dk/integration/ewindow/paymentwindow.js');
                document.getElementsByTagName('head')[0].appendChild(el);
            }

            this.$event_bus.$on('showSubscriptionForm', () => {
                this.loadOrderlines();

                $('#subscription-form-modal').modal('show');
            });

            this.$event_bus.$on('add-new-card', () => {
                this.addSecondaryCreditcard();
            });

            this.$event_bus.$on('onboarding-orderlines', (period) => {
                this.monthly = period;
                this.loadOrderlines();
            });

            let discountCodeFromUrl = getQueryParam('discount');

            if (discountCodeFromUrl) {
                this.discount_code = discountCodeFromUrl;
                this.preapplyDiscount();
            }

            if (this.errorMessage && this.errorMessage.trim() !== '') {
                if (this.from_tour) {
                    swal({
                            title: this.errorMessage,
                            text: trans('onboarding.education_tour_continue_tutorial_description'),
                            showCancelButton: true,
                            cancelButtonText: trans('onboarding.no'),
                            confirmButtonText: trans('onboarding.yes'),
                            showLoaderOnConfirm: true,
                            closeOnConfirm: false,
                            type: 'error',
                    }, (continueTour) => {
                        if (continueTour) {
                                http.get('/app/education-tour')
                                    .then(({ data }) => {
                                        window.location.replace(data.path + '?tour=true')
                                    })
                        } else {
                            http.post('/app/education-tour/skip')
                                .then(() => {
                                    window.location.replace('/app/settings/subscription')
                                })
                        }

                        swal.close()
                    })
                } else {
                    swal(this.errorMessage, '', 'error');
                }
            }
        },

        computed: {
            free_months_available() {
                return this.$store.state.free_months;
            },

            is_eu() {
                return Config.get('countries.' + this.user.country + '.european_union_member');
            },

            terms_url() {
                return trans('global.terms_url');
            },

            period() {
                return this.monthly ? 'monthly' : 'yearly';
            },

            currency() {
                return Config.get('countries.' + this.user.country + '.subscription_currency');
            },

            nice_price_monthly() {
                return Config.get('countries.' + this.user.country + '.subscription_currency') + " " + (this.$store.state.subscription_price_monthly_in_cents / 100);
            },

            nice_price_yearly() {
                return Config.get('countries.' + this.user.country + '.subscription_currency') + " " + (this.$store.state.subscription_price_yearly_in_cents / 100);
            },

            nice_base_price_monthly() {
                return Config.get('countries.' + this.user.country + '.subscription_currency') + " " + (this.$store.state.base_subscription_price_monthly_in_cents / 100);
            },

            nice_base_price_yearly() {
                return Config.get('countries.' + this.user.country + '.subscription_currency') + " " + (this.$store.state.base_subscription_price_yearly_in_cents / 100);
            },

            discountedMonthsForMonthlyPrice() {
                return this.$store.state.custom_monthly_price_months;
            },

            discountedMonthsForYearlyPrice() {
                return this.$store.state.custom_yearly_price_months;
            },

            sub_valid_date_formatted() {
                if (!this.user.invoiceinfo) {
                    return '';
                }
                return moment(this.user.invoiceinfo.sub_valid_date).format("DD-MM-YYYY")
            },

            subscription() {
                return this.period.toUpperCase();
            },

            today() {
                return moment().format("DD-MM-YYYY");
            },

            oneMonthLater() {
                return moment(this.today, "DD-MM-YYYY").add(1, 'M').format("DD-MM-YYYY");
            },

            oneYearLater() {
                return moment(this.today, "DD-MM-YYYY").add(1, 'Y').format("DD-MM-YYYY");
            },

            tax_name() {
                return Config.get('countries.'+ locale +'.tax_name') ?? Config.get('app.default_tax_name');
            },

            tax_id() {
                return Config.get('countries.'+ locale +'.tax_id') ?? Config.get('app.default_tax_name');
            },
        },

        watch: {
            // whenever question changes, this function will run
            step: function (val, oldVal) {
                if(val == 'payment_details'){
                    http.post('/app/user-action/subscription/view-information');
                }
            },
            zip : function (value) {
              this.fetchCityFromZip(value);
              this.$emit('changeZip', value)
            },
        },

        methods: {
            format_amount(amount) {
                return format_amount(amount / 100);
            },

            async applyDiscount() {
                this.loading = true;

                return http.post('/app/settings/subscription/apply-discount', { discount_code: this.discount_code })
                    .then(({ data }) => {
                        swal({
                            title: trans('settings.discount_code.applied_success_title'),
                            type: "success",
                            text: data.message,
                            closeOnConfirm: true,
                        });
                        this.loadOrderlines();
                        this.user.bank = data.user_bank;
                        this.$store.dispatch('reloadState');
                    })
                    .catch(({ error, errorBag }) => {
                        this.$setErrorBag(errorBag);
                        this.loading = false;
                    });
            },

            loadOrderlines(add_minimum_charge = false) {
                this.loading = true;
                this.errors.clear();

                return http.get('/app/settings/subscription/orderlines', {
                        params: {
                            period: this.period,
                            action: this.action,
                            cvr : this.step === 'payment_details' ? this.cvr : null,
                            onboarding: this.is_onboarding,
                            tour: this.on_tour,
                            add_minimum_charge,
                        }
                    })
                    .then(({ data }) => {
                        this.orderlines = data;
                        this.loading = false;
                        this.is_vat_registered = data.is_vat_validated_in_eu;
                        this.paymentParams = data.paymentParams;
                        this.has_discounts = data.hasDiscounts;
                        this.has_valid_payment_card = data.has_valid_payment_card;
                        this.$store.dispatch('reloadState');
                    }).catch(() => {});
            },

            selectYearly() {
                this.loading = true;
                this.monthly = false;
                this.loadOrderlines();
            },

            selectMonthly() {
                this.loading = true;
                this.monthly = true;
                this.loadOrderlines();
            },

            submitUserInfoForm() {
                const formData = new FormData(this.$refs['userinfoform']);
                formData.append('period', this.period);
                formData.append('action', this.action);
                formData.append('card_order', this.card_order);
                formData.append('card_action', this.card_action);
                formData.append('is_vat_registered', this.is_vat_registered ? 1 : 0);

                this.loading = true;

                http.post('/app/settings/userinvoiceinfo', formData)
                    .then(({ data }) => {
                        this.errors.clear();

                        if (this.action === 'upgrade' && data.skip_payment_card_step) {
                            window.location.reload();
                            return;
                        }

                        this.openPaymentWindow();
                        this.loading = false;
                    })
                    .catch(({ error, errorBag }) => {
                        this.$setErrorBag(errorBag);
                        this.loading = false;
                    });
            },

            openPaymentWindow() {
                http.post('/app/user-action/subscription/view-payment-modal');

                this.paymentFailureCount = 0;
                this.loading = true;

                // scroll to the top for e-pay window to work properly
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

                http.get('/app/settings/is-user-subscribed')
                    .then(({ data }) => {
                        this.loading = false;

                        if (data.is_user_subscribed && this.action == 'subscribe') {
                            // the user is already subscribed!
                            swal({
                                title: trans('subscription.already_subscribed'),
                                text: trans('subscription.already_subscribed_desc'),
                                showCancelButton: false,
                                showLoaderOnConfirm: true,
                                closeOnConfirm: false,
                            }, function () {
                                window.location.reload();
                            });

                            return;
                        }

                        if (this.paymentProvider === 'onpay') {
                            this.$refs.onpayForm.submit();
                        } else {
                            this.paymentWindow = new PaymentWindow(this.paymentParams);
                            this.paymentWindow.on('declined', this.paymentDeclined);
                            this.paymentWindow.open();
                        }
                    })
                    .catch(({ error, errorBag }) => {
                        this.loading = false;
                        this.$setErrorBag(errorBag);
                    });
            },

            paymentDeclined() {
                this.paymentFailureCount++;

                if (this.paymentFailureCount < 1) {
                    return;
                }

                if (this.paymentParams.amount > 0) {
                    return;
                }

                setTimeout(() => {
                    if (!this.paymentWindow) {
                        return;
                    }

                    this.paymentWindow.close();
                    this.loadOrderlines(true);

                    setTimeout(() => {
                        swal({
                            title: trans('subscription.payment_failed_title'),
                            type: "error",
                            text: trans('subscription.payment_failed_text', { currency: this.currency }),
                            closeOnConfirm: true,
                        });
                    }, 500);    // short timeout between closing the payment window and showing the error swal
                }, 1000);
            },

            renewSubscription() {
                $('#subscription-form-modal').modal('show');
                this.step = 'subscription_resubscribe';
                this.action = 'renew';
                this.loadOrderlines();
            },

            async getSubscriptionInfo() {
                return (await http.get('subscription-info')).data;
            },

            async upgradeToYearly() {
                const { period } = await this.getSubscriptionInfo();

                if (period === 'yearly') {
                    // The subscription is already yearly, so let's just reload the page to make sure
                    // that the user's interface shows up-to-date data.
                    window.location.reload();
                    return;
                }

                $('#subscription-form-modal').modal('show');
                this.step = 'subscription_select';
                this.action = 'upgrade';
                this.selectYearly();
            },

            async creditcardPaymentWindow(action, params) {
                this.step = 'new_creditcard_description';
                this.action = action;
                this.params = params;

                this.$event_bus.$emit('showSubscriptionForm');
            },

            async preapplyDiscount() {
                await this.applyDiscount();

                this.$event_bus.$emit('showSubscriptionForm');
            },

            goToPreviousStep: function (el) {
                this.$event_bus.$emit('goToPreviousStep', el);
            },

            async fetchCityFromZip(zip) {
                const country = this.user.country || locale;
                const isValidZip = isValidZipCode(zip, country);

                if (isValidZip) {
                    this.errors.clear();

                    const response = await http.get('/app/address/city/', { params: { zip, country } });

                    if (response.data) {
                        this.city = response.data;
                    }
                }
            }
        }
    }
</script>

<template>
    <div v-if="!is_onboarding" id="subscription-form-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
        <div class="modal-dialog subscription-form " :class="{ 'modal-lg' : step === 'payment_details' }">
            <div class="m-0 panel panel-color panel-inverse">
                <div class="panel-heading">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h3 class="panel-title">
                        <span v-if=" step === 'subscription_select' "><i class="zmdi zmdi-info-outline m-r-10"></i> {{ trans('settings.overview') }}</span>
                        <span v-if=" step === 'subscription_resubscribe' "><i class="zmdi zmdi-info-card m-r-10"></i> {{ trans('settings.overview') }}</span>
                        <span v-if=" step === 'new_creditcard_description' "><i class="zmdi zmdi-info-outline m-r-10"></i> {{ trans('settings.overview') }}</span>
                        <span v-if=" step === 'payment_details' "><i class="zmdi zmdi-account m-r-10"></i> {{ trans('settings.payment_information') }}</span>
                    </h3>
                </div>
            </div>

            <div class="modal-content">
                <form  id="userinfoform" v-on:submit.prevent="submitUserInfoForm" ref="userinfoform">
                    <div class="p-0 modal-body">
                        <!-- STEP ONE - select subscription -->
                        <div class="row" v-show="step === 'subscription_select' ">
                            <div class="col-xs-12">
                                <!-- Button Heading -->
                                <div class="form-group" v-if="action !== 'upgrade'">
                                    <label for="name" class="control-label">{{ trans('settings.choose_payment_type') }}</label>

                                    <div class="subscription-options">
                                        <div v-on:click="selectMonthly" class="price-option-container pay-monthly" :class="{ selected: monthly }">
                                            <div class="pay-option">
                                                <i class="zmdi zmdi-check" v-if="monthly"></i>
                                                <h3>{{ trans('user.pay_monthly') }}</h3>
                                            </div>
                                            <div class="pay-price">
                                                <div v-if="free_months_available > 0">
                                                    <h3 class="m-0">{{ transChoice('subscription.free_price', free_months_available, { price: currency + ' 0,-'}) }}</h3>
                                                    <small>{{ transChoice('subscription.first_months', free_months_available, { count: free_months_available, price : trans('user.pay_monthly_price', { price : nice_price_monthly } ) }) }}</small>
                                                    <small v-if="discountedMonthsForMonthlyPrice && free_months_available < discountedMonthsForMonthlyPrice">{{
                                                            transChoice('subscription.price_valid_for_months', discountedMonthsForMonthlyPrice - free_months_available, {
                                                                months: discountedMonthsForMonthlyPrice - free_months_available,
                                                                price: nice_base_price_monthly
                                                            })
                                                    }}</small>
                                                </div>
                                                <div v-else-if="discountedMonthsForMonthlyPrice">
                                                    <h3 class="m-0">{{ trans('user.pay_monthly_price', { price : nice_price_monthly } ) }}</h3>
                                                    <small>{{ $filters.capitalize(transChoice('subscription.price_valid_for_months', discountedMonthsForMonthlyPrice, { months: discountedMonthsForMonthlyPrice, price: nice_base_price_monthly })) }}</small>
                                                </div>
                                                <h3 v-else>{{ trans('user.pay_monthly_price', { price : nice_price_monthly } ) }}</h3>
                                            </div>
                                        </div>

                                        <div v-on:click="selectYearly" class="price-option-container pay-yearly" :class="{ selected: !monthly }">
                                            <div class="pay-option pay-option-yearly">
                                                <i class="zmdi zmdi-check" v-if="!monthly"></i>
                                                <h3 >{{ trans('user.pay_yearly') }}</h3>
                                            </div>
                                            <div class="pay-price">
                                                <div v-if="free_months_available > 0">
                                                    <h3 class="m-0">{{ trans('user.pay_yearly_price', { price : nice_price_yearly } ) }}</h3>
                                                    <small v-if="discountedMonthsForYearlyPrice && free_months_available < discountedMonthsForYearlyPrice">{{
                                                            $filters.capitalize(transChoice('subscription.price_valid_for_months', discountedMonthsForYearlyPrice - free_months_available, {
                                                                months: discountedMonthsForYearlyPrice - free_months_available,
                                                                price: nice_base_price_yearly
                                                            }))
                                                    }}.</small>
                                                    <small v-if="free_months_available === 1">
                                                        {{ trans('subscription.free_price_yearly.first') }}
                                                    </small>
                                                    <small v-if="free_months_available > 1 & free_months_available < 11">
                                                        {{ trans('subscription.free_price_yearly.range', { free: free_months_available, paid: 12 - free_months_available }) }}
                                                    </small>
                                                    <small v-if="free_months_available === 11">
                                                        {{ trans('subscription.free_price_yearly.last') }}
                                                    </small>
                                                </div>
                                                <div v-else-if="discountedMonthsForYearlyPrice">
                                                    <h3 class="m-0">{{ trans('user.pay_yearly_price', { price: nice_price_yearly } ) }}</h3>
                                                    <small>{{ $filters.capitalize(transChoice('subscription.price_valid_for_months', discountedMonthsForYearlyPrice, { months: discountedMonthsForYearlyPrice, price: nice_base_price_yearly })) }}</small>
                                                </div>
                                                <h3 v-else>{{ trans('user.pay_yearly_price', { price: nice_price_yearly } ) }}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Loader -->
                                <div class="row clients-list-loading" v-if="loading">
                                    <div class="text-center col-sm-12">
                                        <div class="preloader"></div>
                                    </div>
                                </div>

                                <div class="form-group" :class="{ 'has-error' : errors.has('discount_code') }" v-if="!loading && has_discounts && free_months_available <= 1">
                                    <label for="discount_code" class="control-label">{{ trans('discount_codes.title') }}</label>
                                    <div class="row">
                                        <div class="col-xs-8">
                                            <input type="text" class="form-control" id="discount_code" v-model="discount_code">
                                        </div>
                                        <div class="col-xs-4">
                                            <ep-button class="w-full" start-icon="plus" @click="applyDiscount()">{{ trans('settings.discount_code.add') }}</ep-button>
                                        </div>
                                    </div>
                                    <span v-show="errors.has('discount_code')" class="help-block">
                                    {{ errors.first('discount_code') }}
                                  </span>
                                </div>

                                <!-- Text Description Body -->
                                <div class="form-group" v-if="!loading">
                                    <label for="name" class="control-label">{{ trans('settings.description') }}</label>

                                    <p class="" v-sanitize-html="orderlines.payment_description"></p>
                                </div>

                            </div>
                        </div>

                        <!-- Resubscribe -->
                        <div class="row" v-show="step === 'subscription_resubscribe'">
                            <div class="col-xs-12">
                                <p>{{ trans('user.resume_subscription_1') }}</p>
                                <p>{{ trans('user.resume_sucscription_2') }} <span>{{ sub_valid_date_formatted }}</span></p>
                            </div>
                        </div>

                        <!-- New creditcard -->
                        <div class="row" v-show="step === 'new_creditcard_description'">
                            <div class="col-xs-12">
                                <p>{{ trans('user.add_new_payment_card_1') }}</p>
                                <p v-if="action == 'newCreditcard'">{{ trans('user.add_new_payment_card_2') }}</p>
                                <p>{{ trans('user.add_new_payment_card_3') }}</p>
                            </div>
                        </div>

                        <!-- STEP TWO - Payment Info -->
                        <div class="row" v-show="step === 'payment_details' ">

                            <div class="col-xs-12 col-sm-12 col-md-7">
                                <div class="row">
                                <div class="col-xs-12 col-sm-6">
                                    <div class="form-group" :class="{ 'has-error' : errors.has('name') }">
                                        <label class="control-label">{{ trans('settings.payment_name') }}</label>
                                        <input class="form-control" name="name" type="text" v-model="name" required>
                                        <span v-show="errors.has('name')" class="help-block">{{ errors.first('name') }}</span>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6">
                                    <div class="form-group" :class="{ 'has-error' : errors.has('cvr') }">
                                        <label class="control-label">{{ trans('settings.payment_company_number', {tax_id}) }}</label>
                                        <input class="form-control" name="cvr" type="text" v-model="cvr" @blur="loadOrderlines">
                                        <span v-show="errors.has('cvr')" class="help-block">{{ errors.first('cvr') }}</span>
                                    </div>
                                </div>


                                <div class="col-xs-12">
                                    <div class="form-group" :class="{ 'has-error' : errors.has('address') }">
                                        <label class="control-label">{{ trans('settings.payment_address') }}</label>
                                        <input class="form-control" name="address" type="text"  v-model="address" required>
                                        <span v-show="errors.has('address')" class="help-block">{{ errors.first('address') }}</span>
                                    </div>
                                </div>


                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group" :class="{ 'has-error' : errors.has('zip') }">
                                        <label class="control-label">{{ trans('settings.profile_zip') }}</label>
                                        <input class="form-control" name="zip" type="text" v-model="zip" required>
                                        <span v-show="errors.has('zip')" class="help-block">{{ errors.first('zip') }}</span>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-8">
                                    <div class="form-group" :class="{ 'has-error' : errors.has('city') }">
                                        <label class="control-label">{{ trans('settings.profile_city') }}</label>
                                        <input class="form-control" name="city" type="text" v-model="city" required>
                                        <span v-show="errors.has('city')" class="help-block">{{ errors.first('city') }}</span>
                                    </div>
                                </div>


                                <div class="col-xs-12 col-sm-6">
                                    <div class="form-group mail-input" :class="{ 'has-error' : errors.has('email') }">
                                        <label class="control-label">{{ trans('global.email') }}</label>
                                        <input class="form-control" type="text" name="email" v-model="email" required>
                                        <span v-show="errors.has('email')" class="help-block">{{ errors.first('email') }}</span>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6">
                                    <div class="form-group" :class="{ 'has-error' : errors.has('phone') }">
                                        <label class="control-label">{{ trans('settings.profile_phone') }}</label>
                                        <input class="form-control" name="phone" type="text" v-model="phone">
                                        <span v-show="errors.has('phone')" class="help-block">{{ errors.first('phone') }}</span>
                                    </div>
                                </div>

                                <div class="col-xs-12">
                                    <div class="" :class="{ 'has-error' : errors.has('conditions') }">
                                        <div class="checkbox checkbox-custom m-t-0" style="margin-bottom: 10px;">
                                            <input id="conditions" name="conditions" type="checkbox">
                                            <label for="conditions">
                                                {{ trans('settings.i_accept') }} <a :href="terms_url" target="_new" class="conditions-link ml-2" >{{ trans('settings.conditions') }} <i class="ml-1 fa fa-external-link"></i></a>
                                            </label>
                                        </div>
                                        <span v-show="errors.has('conditions')" class="help-block">{{ errors.first('conditions') }}</span>
                                    </div>
                                </div>

                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-5">

                                <ep-banner class="text-sm space-y-3" v-if="orderlines.amount == 0 || (is_eu && user.country !== 'da')">
                                    <span class="block" v-if="orderlines.amount == 0">{{ trans('subscription.reservation_notice', { currency : currency }) }}</span>
                                    <span v-if="is_eu && user.country !== 'da'" class="block m-t-10" v-sanitize-html="trans('subscription.eu_vat_message')"></span>
                                </ep-banner>

                                <!-- Totals Section -->
                                <div class="form-group order-overview">
                                    <label class="control-label">{{ trans('settings.order_overview') }}</label>

                                    <!-- LIST OF ITEMS, PRODUCTS AND DISCOUNTS -->
                                    <div  v-for="orderline in orderlines.orderlines">
                                        <div class="price-flex-display">
                                            <p class="orderline-text" v-sanitize-html="orderline.text"></p>
                                            <p>{{ orderline.amount }}</p>
                                        </div>
                                    </div>

                                    <div class="legal-line top-line-div">
                                        <!-- Subtotal + VAT LINE, only if VAT is applied -->
                                        <template v-if="orderlines.vat">
                                            <div class="price-flex-display">
                                                <p>{{ trans('invoice.subtotal') }}</p>
                                                <p>{{ orderlines.subtotal_formatted }}</p>
                                            </div>
                                            <div class="price-flex-display">
                                                <p>{{ $filters.capitalize(tax_name) }} ({{ orderlines.vat_percentage }}%) <i class="zmdi zmdi-help" v-tooltip="trans('subscription.danish_vat_applied')" v-if="is_eu && user.country !== 'da'"></i></p>
                                                <p>{{ orderlines.vat_formatted }}</p>
                                            </div>
                                        </template>

                                        <div class="price-flex-display">
                                            <p>{{ trans('settings.total') }} {{ currency }}</p>
                                            <p>{{ orderlines.total_formatted }} </p>
                                        </div>
                                    </div>
                                </div>

                                <ep-banner v-if="orderlines.amount == 0 && paymentParams.amount == 100" class="mt-6">
                                    <p>{{ trans('subscription.payment_failed_text', { currency: currency }) }}</p>
                                </ep-banner>

                                <form method="post" action="https://onpay.io/window/v3/" class="hidden" ref="onpayForm">
                                    <input v-for="(value, key) in paymentParams" :key="key" type="hidden" :name="key" :value="value" />
                                    <input v-for="(value, key) in params" :key="key" type="hidden" :name="key" :value="value" />
                                </form>

                            </div>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-xs-12 m-t-10">

                                <ep-button variant="tertiary" class="float-left" v-if="step === 'payment_details'" @click.prevent="step='subscription_select'" start-icon="arrow-left">{{ trans('global.back') }}</ep-button>

                                <ep-button v-show="step === 'subscription_select' " @click.prevent=" step = 'payment_details' " end-icon="arrow-right">{{ trans('settings.continue') }}</ep-button>

                                <ep-button v-show="step === 'subscription_resubscribe' " @click.prevent=" step = 'payment_details' " end-icon="arrow-right">{{ trans('settings.continue') }}</ep-button>

                                <ep-button v-show="step === 'new_creditcard_description' && ['addSecondaryCreditcard', 'newCreditcard', 'reAuthoriseCreditCard'].includes(action)"
                                           @click.prevent="openPaymentWindow"
                                           end-icon="arrow-right"
                                >{{ trans('settings.continue') }}</ep-button>

                                <ep-button
                                    v-show="step === 'payment_details'"
                                    type="submit"
                                    :disabled="loading"
                                    :end-icon="!has_valid_payment_card ? 'arrow-right' : ''"
                                    :start-icon="has_valid_payment_card ? 'check' : ''"
                                >
                                    <template v-if="has_valid_payment_card">
                                        {{ trans('settings.upgrade_confirm') }}
                                    </template>
                                    <template v-else>
                                        <span class="hidden-sm hidden-md hidden-lg hidden-xl">{{ trans('settings.subscribe_confirm_short') }}</span>
                                        <span class="hidden-xs">{{ trans('settings.subscribe_confirm') }}</span>
                                    </template>
                                </ep-button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div v-else>
        <h1>{{ trans('settings.payment_information') }}</h1>
        <ep-banner variant="warning" class="m-b-15">
            <small v-if="has_discounts && !wantsToSubscribe && orderlines.number_of_free_months">
                {{ transChoice('onboarding.payment_offer', orderlines.number_of_free_months || 1, { months: orderlines.number_of_free_months }) }}
            </small>
            <small v-else-if="has_discounts && !wantsToSubscribe && orderlines.monthly_price_months > 0">
                {{ trans('onboarding.payment_offer_adjustment_1') }}
                {{
                    transChoice(orderlines.vat > 0 ? 'onboarding.payment_offer_adjustment_2_vat' : 'onboarding.payment_offer_adjustment_2', orderlines.monthly_price_months, {
                        months: orderlines.monthly_price_months, currency: currency, price: orderlines.monthly_price_formatted
                    })
                }}
                {{ trans('onboarding.payment_offer_adjustment_3') }}
            </small>
            <small v-else>{{ trans('onboarding.payment_free_first_month') }}</small>
        </ep-banner>
        <div class="row">
            <form  id="userinfoform" v-on:submit.prevent="submitUserInfoForm" ref="userinfoform">
                <div class="col-sm-6" :class="{ 'has-error' : errors.has('name') }">
                    <label for="name">{{ trans('settings.profile_name') }}</label>
                    <input class="form-control" value="" required name="name" :placeholder="trans('settings.profile_name')" v-model="name">
                    <span v-show="errors.has('name')" class="help-block">{{ errors.first('name') }}</span>
                </div>
                <div class="col-sm-6" :class="{ 'has-error' : errors.has('cvr') }">
                    <label for="cvr">{{ tax_id }}</label>
                    <input class="form-control" value="" required name="cvr" :placeholder="tax_id" v-model="cvr">
                    <span v-show="errors.has('cvr')" class="help-block">{{ errors.first('cvr') }}</span>
                </div>
                <div class="col-sm-12" :class="{ 'has-error' : errors.has('address') }">
                    <label for="address">{{ trans('settings.profile_address') }}</label>
                    <input class="form-control" value="" required name="address" :placeholder="trans('settings.profile_address')" v-model="address">
                    <span v-show="errors.has('address')" class="help-block">{{ errors.first('address') }}</span>
                </div>
                <div class="col-sm-6" :class="{ 'has-error' : errors.has('zip') }">
                    <label for="zip">{{ trans('settings.profile_zip') }}</label>
                    <input class="form-control" value="" required name="zip" :placeholder="trans('settings.profile_zip')" v-model="zip">
                    <span v-show="errors.has('zip')" class="help-block">{{ errors.first('zip') }}</span>
                </div>
                <div class="col-sm-6" :class="{ 'has-error' : errors.has('city') }">
                    <label for="city">{{ trans('settings.profile_city') }}</label>
                    <input class="form-control" value="" required name="city" :placeholder="trans('settings.profile_city')" v-model="city">
                    <span v-show="errors.has('city')" class="help-block">{{ errors.first('city') }}</span>
                </div>
                <div class="col-sm-6" :class="{ 'has-error' : errors.has('email') }">
                    <label for="email">{{ trans('global.email') }}</label>
                    <input class="form-control" value="" required name="email" :placeholder="trans('global.email')" v-model="email">
                    <span v-show="errors.has('email')" class="help-block">{{ errors.first('email') }}</span>
                </div>
                <div class="col-sm-6" :class="{ 'has-error' : errors.has('phone') }">
                    <label for="phone">{{ trans('settings.profile_phone') }}</label>
                    <input class="form-control" value="" required name="phone" :placeholder="trans('settings.profile_phone')" v-model="phone">
                    <span v-show="errors.has('phone')" class="help-block">{{ errors.first('phone') }}</span>
                </div>

                <div v-if="(is_eu && user.country !== 'da') || orderlines.amount == 0" class="col-xs-12 text-normal m-t-15">

                    <small class="block m-b-10" v-if="orderlines.amount == 0">{{ trans('subscription.reservation_notice', { currency : currency }) }}</small>

                    <small class="block" v-if="is_eu && user.country !== 'da'" v-sanitize-html="trans('subscription.eu_vat_invalid_form_description')"></small>

                </div>


                <div class="col-xs-12 text-normal checkbox-conditions">
                    <div class="checkbox checkbox-custom" style="margin-bottom: 10px;" :class="{ 'has-error' : errors.has('conditions') }">
                        <input id="conditions" name="conditions" type="checkbox">
                        <label for="conditions">{{ trans('settings.i_accept') }} <a :href="terms_url" target="_new" class="conditions-link ml-2">{{ trans('settings.conditions') }}</a></label>
                    </div>
                    <span v-show="errors.has('conditions')" class="help-block">{{ errors.first('conditions') }}</span>
                </div>
                <div class="col-xs-12 m-t-30">
                    <form method="post" action="https://onpay.io/window/v3/" class="hidden" ref="onpayForm">
                        <input v-for="(value, key) in paymentParams" :key="key" type="hidden" :name="key" :value="value" />
                    </form>

                    <ep-button size="lg" @click.prevent="submitUserInfoForm" end-icon="arrow-right">{{ trans('onboarding.subscription_6') }}</ep-button>
                </div>
            </form>
        </div>

        <div class="text-small text-muted m-t-20 pointer" @click="goToPreviousStep()"><i class="zmdi zmdi-arrow-left m-r-10"></i>{{ trans('settings.template_back_confirm_title') }}</div>
    </div>
</template>
